export default {"src":"/_next/static/media/napacabbage.14d6cff5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};